import { isProduction } from "@/config/config";
import { LANDING } from "@/content/marketing";
import { landingPageJsonLd, landingRouteHead } from "./landing-seo";
import { SITE_URL } from "./marketing-jsonld";

export const AI_BLOG_URL = `${SITE_URL}ai-blogging-platform`;
export const AI_BLOG_TITLE = "GoodSender: The AI-first blog platform";
export const AI_BLOG_DESCRIPTION =
  "Write, preview and publish from Claude or ChatGPT via the official MCP server. Your blog, your domain, your newsletter. Also write in the editor.";

export const aiBlogPageJsonLd = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  name: "GoodSender",
  applicationCategory: "BusinessApplication",
  applicationSubCategory: "Blog & Newsletter Platform",
  operatingSystem: "Web",
  url: AI_BLOG_URL,
  description: `${AI_BLOG_DESCRIPTION} Review each post and choose where it goes.`,
  offers: landingPageJsonLd.offers,
  creator: landingPageJsonLd.creator,
  featureList: [
    ...LANDING.destinations.items.map((item) => `${item.name}: ${item.body}`),
    ...LANDING.proof.points.map((point) => `${point.name} ${point.body}`),
  ],
};

export function aiBlogRouteHead(): { meta: Record<string, string>[]; links: Record<string, string>[] } {
  return {
    meta: [
      { title: AI_BLOG_TITLE },
      { name: "description", content: AI_BLOG_DESCRIPTION },
      { name: "robots", content: isProduction ? "index, follow, max-image-preview:large" : "noindex, nofollow" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: AI_BLOG_URL },
      { property: "og:title", content: AI_BLOG_TITLE },
      { property: "og:description", content: AI_BLOG_DESCRIPTION },
      { property: "og:site_name", content: "GoodSender" },
      { property: "og:image", content: `${SITE_URL}og-ai-blogging.png` },
      { property: "og:image:width", content: "1200" },
      { property: "og:image:height", content: "630" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: AI_BLOG_TITLE },
      { name: "twitter:description", content: AI_BLOG_DESCRIPTION },
      { name: "twitter:image", content: `${SITE_URL}og-ai-blogging.png` },
    ],
    links: [
      { rel: "canonical", href: AI_BLOG_URL },
      // Preserve the original landing's llms.txt, full reference, and API
      // discovery links while giving this page its own canonical URL.
      ...landingRouteHead().links.filter((link) => link.rel !== "canonical"),
    ],
  };
}
